import $ from 'jquery';
import 'bootstrap';
import enableBreadcrumbsFunctionality from 'Common/breadcrumbs';
import enableCommonFunctionality from './common';
import enableNavigationBarFunctionality from './navigation-bar';
import enableStayInformedFunctionality from './stay-informed';
import enableAboutFunctionality from './about';
import enableContactFunctionality from './contact';
import enableMediaKitFunctionality from './media-kit';
import enableNetworkFunctionality from './network';
import enableNewsArticleFunctionality from './news-article';
// wait until the DOM loads
$(() => {
    // enable common functionality
    enableBreadcrumbsFunctionality();
    enableCommonFunctionality();
    enableNavigationBarFunctionality();
    enableStayInformedFunctionality();
    // enable specific page functionality
    enableAboutFunctionality();
    enableContactFunctionality();
    enableMediaKitFunctionality();
    enableNetworkFunctionality();
    enableNewsArticleFunctionality();
});
